import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { TranslateModule } from '@ngstack/translate';

import { SharedModule } from '@shared/shared.module';

import { AuthPitchPillComponent } from './components/auth-pitch-pill/auth-pitch-pill.component';
import { WalkthroughDotsComponent } from './components/walkthrough-dots/walkthrough-dots.component';
import { WalkthroughPane1Component } from './components/walkthrough-pane1/walkthrough-pane1.component';
import { WalkthroughPane2Component } from './components/walkthrough-pane2/walkthrough-pane2.component';
import { WalkthroughPane3Component } from './components/walkthrough-pane3/walkthrough-pane3.component';
import { WalkthroughPane4Component } from './components/walkthrough-pane4/walkthrough-pane4.component';
import { WalkthroughPane5Component } from './components/walkthrough-pane5/walkthrough-pane5.component';
import { WalkthroughPane6Component } from './components/walkthrough-pane6/walkthrough-pane6.component';
import { WalkthroughPane7Component } from './components/walkthrough-pane7/walkthrough-pane7.component';
import { WalkthroughPane8Component } from './components/walkthrough-pane8/walkthrough-pane8.component';
import { WalkthroughSlideComponent } from './components/walkthrough-slide/walkthrough-slide.component';
import { WalkthroughPage } from './walkthrough.page';

/**
 * The eight-pane Introduction Walkthrough, ported from koomzodesignsystem (specs/auth.md §5.4).
 * It opens only from Login and Signup (kz2 F1): it is no longer part of the entry flow.
 *
 * The design is a shared frame with eight BESPOKE bodies (D31.3). `WalkthroughPage` owns the bar,
 * dots, counter, prev/next and arrow keys. `WalkthroughSlideComponent` owns the copy-beside-
 * illustration frame seven panes share. The pane components own what they say.
 *
 * `AuthPitchPillComponent` is exported for Login and Signup, which show pills in their pitch column.
 */
@NgModule({
  imports: [SharedModule, RouterModule, TranslateModule.forChild()],
  declarations: [
    WalkthroughPage,
    WalkthroughSlideComponent,
    WalkthroughDotsComponent,
    WalkthroughPane1Component,
    WalkthroughPane2Component,
    WalkthroughPane3Component,
    WalkthroughPane4Component,
    WalkthroughPane5Component,
    WalkthroughPane6Component,
    WalkthroughPane7Component,
    WalkthroughPane8Component,
    AuthPitchPillComponent
  ],
  exports: [WalkthroughPage, AuthPitchPillComponent]
})
export class WalkthroughModule {}
